import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Assignment } from 'src/features/pricingPlans/types';
import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/assignments/specific-purpose/';

interface DTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Assignment>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_SPECIFIC_PURPOSE_ASSIGNMENTS_RESOURCE,
    queryFn as listSpecificPurposeAssignments,
    useQueryHook as useListSpecificPurposeAssignments,
};
